// export const SERVER_URL = 'http://localhost:4000/';
// export const SERVER_URL = 'http://185.179.83.227:4000/';

export const SERVER_URL = 'https://api.skrama24.by/';
// export const SERVER_URL = 'https://skrama-server.onrender.com/';
export const API_URL = SERVER_URL + 'api/';


// https://skrama-server.onrender.com